"use client";

import { useEffect } from "react";
import Bugsnag from "@bugsnag/js";

const ErrorPage = ({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useEffect(() => {
    Bugsnag.notify(error, (event) => {
      event.severity = "error";
      event.unhandled = true;
    });
  }, [error]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>Something went wrong</h2>
    </div>
  );
};

export default ErrorPage;
